module.exports = __webpack_public_path__ + "img/logo-recuperi-equifax.461d57d5.png";